<template>
  <div class="theme_details">
    <!--  :src="imgPrefix + detail.banner" -->
    <img class="banner clearfix" alt="" />
    <div class="w flex" style="justify-content: space-between; height: 17rem">
      <div class="ban_l" style="margin-top: 0">
        <div class="tit" style="color: #fff">{{ detail.name }}</div>
        <div class="desc" style="width: 699px;" v-html="formatIntroduction(detail.introduction)"></div>
        <div class="flex">
          <div class="bon_col" v-if="isApply&&isUnion == 1">
            <div class="handle flex_box" @click="gotoWork(1)">
              <img src="../../assets/icon/icon-handle.png" alt="" /> <span>线上办理</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="number_box">
        <div class="flex_box title">
          <div>原来</div>
          <div>当前</div>
        </div>
        <div class="flex_box box_li">
          <div>跑动次数</div>
          <div>
            <span class="line">{{detail.runNumTotal||0}}  次</span>
          </div>
          <img src="../../assets/icon-arrow-right.png" alt="">
          <div class="flex_box"><span class="num">{{detail.runNum||0}}</span>次</div>
        </div>
        <div class="flex_box box_li">
          <div>递交材料</div>
          <div>
            <span class="line">{{detail.materialNumTotal||0}}  份</span>
          </div>
          <img src="../../assets/icon-arrow-right.png" alt="">
          <div class="flex_box"><span class="num">{{detail.materialNum||0}} </span>份</div>
        </div>
        <div class="flex_box box_li">
          <div>关联事项</div>
          <div>
            <span class="line">{{detail.unionServiceTotal||0}}  个</span>
          </div>
          <img src="../../assets/icon-arrow-right.png" alt="">
          <div class="flex_box"><span class="num">{{detail.unionService||0}}</span>个</div>
        </div>
      </div> -->
      
    </div>
    <!-- 描点栏 -->
    <a-anchor :target-offset="targetOffset" class="anchor_box">
      <a-anchor-link href="#service_map" title="服务地图" />
      <a-anchor-link href="#process" title="办理流程" />
      <a-anchor-link href="#file" title="办理材料" />
      <a-anchor-link href="#question" title="常见问题" />
    </a-anchor>
    <div class="w">
      <div class="navi_top">
        当前位置：<span @click="returnFn">一件事专区</span> /
        {{ detail.name }}专区
      </div>
    </div>
    <div class="w service_map">
      <div class="ser_title" id="service_map">服务地图</div>
      <!-- 一体化办理 -->
      <template v-if="isUnion == 1">
        <div class="step_ul">
          <div class="step_li flex_box" v-for="(item, index) in stepList" :key="index">
            <div class="title_box">
              <img src="../../assets/pic-map.png" alt="" />
              <div class="title">{{ item }}</div>
            </div>
            <div class="arrow_box" v-if="index!=stepList.length-1">
              <img src="../../assets/icon/pic_arrow_right.png" alt="">
              <!-- <div class="line">
                <div class="right_arrow"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="content_box">
          <div v-for="(item,idx) in processList" :key="idx" class="process_li">
            <div class="top_box flex_box">
              <div class="order_box">{{item.step}}</div>
              <div class="title">{{item.stepName}}</div>
              <div :class="['tag',item.processType==1?'tag_red':'tag_green']">{{item.processType==1?'必办':'选办'}}</div>
              <a-tooltip placement="right">
                <template slot="title">
                  <span>{{item.attention}}</span>
                </template>
                <img v-if="item.attention" src="../../assets/pic-question.png" alt="" />
              </a-tooltip>
            </div>
            <div class="info_box">
              <div>
                <div v-for="(it,index) in item.stepContentArr" :key="index" class="flex step_content">
                  <template v-if="item.stepName != '现场报到'">
                    <img v-if="item.stepName=='报到注册'||item.stepName=='学费缴纳'" src="../../assets/pic-check.png" alt="" />
                     <img v-if="item.stepName=='绿色通道'" src="../../assets/pic-radio.png" alt="" />
                     <div>{{ it }}</div>
                  </template> 
                  <template v-else>
                    <!-- 线性流程 -->
                    <div class="flex_box" :style="index != item.stepContentArr.length-1?'margin-bottom: 80px':''">
                      <img src="../../assets/pic-check.png" alt="" />
                      <div>{{it}}</div>
                    </div>
                    <div v-if="index != item.stepContentArr.length-1" class="down_arrow flex">
                      <img src="../../assets/icon/icon_arrow_down.png" alt="" />
                      <div>通过人脸识别校验，通过地点定位校验</div>
                    </div>
                  </template>
                 </div>
                <!-- <div>{{item.stepContent}}</div> -->
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 分开办理:class="['process_li bg_img', 
          item.name === '教职工报修' ? 'blue_bg_img' : item.name === '学生报修' ? 'green_bg_img' : '']" -->
      <template v-else-if="isUnion == 0">
        <div class="content_box">
          <div class="process_li" v-for="(item,index) in modules" :key="index">
            <div class="lock-img">
              <img src="../../assets/repair/lock-img.png" alt="">
            </div>
          <div class="process_con">
            <div class="img_container">
              <img v-if="item.name === '教职工报修'" src="../../assets/repair/man-img.png" alt="教职工报修" class="repair_img">
              <img v-else-if="item.name === '学生报修'" src="../../assets/repair/women-img.png" alt="学生报修" class="repair_img">
            </div>
            <div class="top_box flex_box">
              <div class="flex_box">
                <div class="title">{{item.name}}</div>
              </div>
              <div class="handle flex_box" v-if="item?.isUnion == 1" @click="gotoWork(2,item)">线上办理</div>
            </div>
            <div class="info_box" v-if="item?.isUnion == 1">
              <div class="step_content" v-for="(it,idx) in item?.unionServiceSummaryVo?.unionServiceProcessVo?.process || []" :key="idx">
                <div class="flex_box" :style="idx != (item?.unionServiceSummaryVo?.unionServiceProcessVo?.process?.length || 0) - 1 ? 'margin-bottom: 50px':''">
                  <img src="../../assets/icon/icon-tool.png" alt="" />
                  <div>{{it?.stepName || ''}}</div>
                </div>
                <div class="down_arrow flex" v-if="idx != (item?.unionServiceSummaryVo?.unionServiceProcessVo?.process?.length || 0) - 1" style="top: 27px;">
                  <img src="../../assets/icon/icon_arrow_down.png" alt="" />
                  <div style="color: #999;" v-if="item?.name == '一网通办'">假期结束</div>
                </div>
              </div>
            </div>
            <div class="info_box repair_box" v-else>
              <template v-if="item?.unionServiceSummaryVoList?.length>0">
                <div class="step_content" v-for="(it,idx) in item?.unionServiceSummaryVoList" :key="idx">
                    <div class="flex_box" style="justify-content: space-between;">
                      <div class="flex_box">
                        <img src="../../assets/icon/icon-tool.png" alt="" style="margin-right: 10px;" />
                        <div class="step_title">{{it?.serviceManage?.serviceManageName}}</div>
                      </div>
                      <div class="flex_box" style="align-items: center;">
                        <div class="bon_l" @click="gotoDetails(it?.serviceManage)">办事指南</div>
                        <div 
                          class="handle flex_box smile" 
                          :style="{ backgroundColor: it?.serviceManage?.way == 2 ? '#e2e0e0' : '' }" 
                          @click="gotoWork(3,it)">
                          {{it?.serviceManage?.way==1?'线上办理':it?.serviceManage?.way==0?'线上和线下':it?.serviceManage?.way==2?'线下办理':'--' }}
                        </div>
                      </div>
                    </div>
                  <div class="desc" v-html="formatDescription(it?.serviceManage?.description)" style="margin-top: 10px; line-height: 1.6; color: #666;"></div>
                </div>
              </template>
            </div>
          </div>

          </div>

        </div>
      </template>

      <div class="content_bom" id="process">
        <!-- tab栏 -->
        <div class="flex_box tabs">
          <div
            :class="['bon', index == tabIdx ? 'click_sty' : '']"
            v-for="(item, index) in tabList"
            :key="index"
            :id="item.id"
            @click="tabChange(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <template v-if="tabIdx == 0">
         <div class="pic_box" v-if="processDiagram">
          <img class="amplify" src="../../assets/pic-amplify.png" @click="previewVisible=true" alt="">
          <img style="width: auto;height: 100%;" :src="imgPrefix + (processDiagram || '')" alt="">
         </div>
         <div v-else>暂无流程图~</div>
        </template>
        <template v-if="tabIdx == 1">
          <div
            class="file_class flex"
            v-for="item in (fileList || [])"
            :key="item?.id"
          >
            <div class="flex">
              <img
                style="margin-right: 16px"
                src="../../assets/icon/icon-word.png"
                alt=""
              />
              <div>{{ item?.name || '' }}.{{ item?.suffix || '' }}</div>
            </div>
            <a
              class="flex"
              :href="imgPrefix + (item?.materialId || '')"
              :download="item?.name || ''"
            >
              <div>下载</div>
              <img src="../../assets/icon/icon-down-img.png" alt="" />
            </a>
          </div>
          <div v-if="(fileList || []).length == 0"> 暂无</div>
        </template>
        <template v-if="tabIdx == 2">
          <div class="question" v-if="(questionList || []).length > 0">
            <div
              v-for="(item, idx) in (questionList || [])"
              :key="idx"
              :class="item?.ask ? 'ques_con' : 'ques_list'"
            >
              <div style="margin-bottom: 16px;justify-content: space-between;" class="flex">
                <div><span class="wen">问：</span>{{ item?.question || '' }}</div>
                <!-- <div>
                  <a-icon v-if="!item.checked" @click="changeCheck(idx,1)" type="down" style="cursor: pointer;"/>
                  <a-icon v-else @click="changeCheck(idx,0)" type="up" style="cursor: pointer;"/>
                </div> -->
              </div>
              <!--  v-if="item.checked" -->
              <div style="display: flex;">
                <span class="da">答：</span >
                <div v-html="formatDescription(item?.ask || '')" class="da_con"></div>
              </div>
            </div>
          </div>
          <div v-else>暂无问题~</div>
        </template>
      </div>
    </div>

    <!-- 预览图片 -->
    <a-modal :width="800" :visible="previewVisible" :footer="null" @cancel="previewVisible=false">
      <img alt="example" style="width: 100%" :src="imgPrefix + (processDiagram || '')" />
    </a-modal>

  </div>
</template>

<script>
import imgPrefix from "../../../utils/imgPrefix";
import {
  findUnionByIdApi,
  usageLogsApi
} from "@/api/index";
export default {
  data() {
    return {
      loading: false,
      imgPrefix,
      tabIdx: 0,
      themeId: "",
      previewVisible: false,
      previewImage: "",
      isApply: true,
      stepList: ["报到注册", "入学教育考试", "军训服装填报","绿色通道", "学费缴费", "现场报到"],
      tabList: [
        { id: "process", name: "办理流程" },
        { id: "file", name: "办理材料" },
        { id: "question", name: "常见问题" },
      ],
      detail: {},
      targetOffset: undefined,
      processList: [],
      processDiagram: '', //	办理流程图
      questionList: [],
      fileList: [],
      isUnion: '',
      modules: [],
    };
  },
  created() {
    this.targetOffset = window.innerHeight / 2;
    // 获取专区名称简介
    let themeId = this.$route.query.themeId;
    this.getfindUnionById(themeId)
    // 获取常见问题
    // findThemeAqByThemeIdApi(themeId).then(res => {
    //   // console.log(res);
    //   res.forEach(item => {
    //     item.checked = false;
    //   })
    //   this.questionList = res;
    // })
  },
  mounted() {},
  methods: {
    // 格式化描述文本，将换行符转换为<br>标签，并为每一行添加黑色圆点
    formatDescription(text) {
      if (!text) return '';
      // 将文本按换行符分割，为每一行添加黑色圆点，然后重新组合
      return text.split('\n').map(line => {
        if (line.trim()) {
          return `<div style="display: flex; align-items: center; margin-bottom: 8px;">
            <span style="display: inline-block; width: 6px; height: 6px; background-color: #000; border-radius: 50%; margin-right: 8px; flex-shrink: 0;"></span>
            <span style="line-height: 1.5;">${line}</span>
          </div>`;
        }
        return line;
      }).join('');
    },
    // 格式化介绍文本，为数字、个、多等字添加高亮样式，保留其他字符透明度
    formatIntroduction(text) {
      if (!text) return '';
      // 将文本按字符分割处理，保留透明度但高亮特定字符
      return text.split('').map(char => {
        if (/\d/.test(char) || char === '个' || char === '多') {
          return ` <span style="color: #F2FF00;">${char}</span> `;
        } else {
          return `<span style="opacity: 0.8;">${char}</span>`;
        }
      }).join('');
    },
    // 获取详情
    getfindUnionById(themeId){
      findUnionByIdApi(themeId).then(res => {
        console.log(res,'----------详情');
        this.detail = res;
        this.isUnion = res.isUnion;
        this.processDiagram = res.processDiagram;
        if(res.isUnion == 1){//0:分开办理, 1:一体化办理
          this.fileList = res?.unionServiceSummaryVo?.serviceMaterialVo || [];
          let arr = res?.unionServiceSummaryVo?.unionServiceProcessVo?.process || [];
          let newArr = []
          if(arr.length > 0){
            arr.forEach(item => {
              if(item.stepContent){
                item.stepContentArr = item.stepContent.split('；')
              }
              newArr.push(item.stepName)
            })
          }
          this.processList = arr;
          // console.log(this.processList,'this.processList');
          
          this.stepList = newArr;
        }else if(res.isUnion == 0){
          this.modules = res.modules || [];
          
          this.fileList = res?.modules?.unionServiceSummaryVoList?.serviceMaterialVo || [];
        }
        // 常见问题
        let aqList = res.aqList || []
        if(aqList.length > 0){
          aqList.forEach(item => {
            item.checked = false;
          })
        }
        this.questionList = aqList;   
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    returnFn() {
      // this.$router.go(-1)
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      naviTop.forEach((item) => {
        if (item.link == "/theme") {
          this.$router.push("/theme?naviId=" + item.id);
        }
      });
    },
    // 办理
    gotoWork(val,item) {
      if(val == 1){
        window.open('https://yx.hbmzu.edu.cn:6121/#/yxxc');
      }else if(val == 2){
        let url = item?.unionServiceSummaryVo?.unionServiceVo?.pcUrl;
        window.open(url);
      }else if(val == 3){
        console.log(item);
        if(item?.serviceManage?.way == 2){
          this.$message.warning('当前服务仅支持线下办理')
        }else{
          let url = item?.serviceManage?.pcUrl;
          window.open(url);
        }
      }
    },
    // 查看指南
    gotoDetails(e) {
      let dto = {
        "serviceId": e.id,
        "userId": "",
       }
       let userId = sessionStorage.getItem('userId');
       if(userId){
        dto.userId = userId;
       }
      usageLogsApi(dto).then(res => {})
      let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
      let idx = "";
      if (naviTop) {
        naviTop.forEach((item, index) => {
          if (item.link == "/serviceHall") {
            idx = index;
          }
        });
      }
      this.$router.push(
        "/serviceDetails?index=" + idx + "&serviceManageId=" + e.id
      );
    },
    tabChange(idx) {
      this.tabIdx = idx;
    },
    changeCheck(idx,num){
      console.log(idx,num);
      this.questionList[idx].checked = num == 1 ? true : false;
      console.log(this.questionList);
      
      // let checked = num == 1 ? true : false;
      // this.$set(this.questionList[idx],'checked',checked)
      // this.questionList = this.questionList
    },
  },
};
</script>

<style scoped lang="less">
.theme_details {
  .flex_box {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
  }
  .banner {
    width: 100%;
    min-height: 17rem;
    text-align: left;
    position: absolute;
    left: 0;
    object-fit: cover;
    background: url('../../assets/theme-banner.png') center;
  }
  .number_box{
    background: rgba(255,255,255,.6);
    padding: 12px 24px;
    border-radius: 12px;
    color: #858080;
    z-index: 99;
    font-size: 22px;
    .title{
      margin-left: 60px;
      justify-content: right;
      font-weight: 600;
      margin-bottom: 6px;
      div:last-child{
        margin-left: 63px;
        color: var(--themeSloganColor);
      }
    }
    .box_li{
      margin-bottom: 4px;
      div:first-child{
        margin-right: 30px;
      }
      .line{
        margin-left: 6px;
        position: relative;
      }
      .line::before{
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        background: #9c9898;
      }
      .num{
        color: var(--themeSloganColor);
        font-weight: 600;
        margin-right: 6px;
      }
    }
    img{
      width: 32px;
      height: 26px;
      margin: 0 16px;
    }
  }
  .navi_top {
    position: absolute;
    top: 155px;
    color: #fff;
    opacity: 0.8;
    span {
      cursor: pointer;
    }
  }
  .bon_col {
    margin-top: 24px;
    margin-right: 4%;
    div {
      border-radius: 8px;
      padding: 0.8rem 0.85rem;
      font-size: 18px;
      background: #fff;
      margin-right: 12px;
      cursor: pointer;
      img {
        margin-right: 10px;
      }
    }
    .handle {
      background: var(--themeColor);
      color: #fff;
      cursor: pointer;
    }
  }
  .anchor_box{
    position: absolute;
    left: 75px;
    // top: 26%;
    top: 485px;
    z-index: 99;
  }
  .service_map {
    margin-top: 30px;
    .ser_title {
      font-size: 28px;
      font-weight: 600;
      text-align: left;
    }
    .step_ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 100px;
      .step_li {
        position: relative;
        align-items: normal;
        width: 100%;
        &:last-child{
         width: 50%;
        }
        .title_box{
          width: 100%;
          .title{
            display: flex;
            justify-content: center;
            flex-wrap: nowrap;
          }
        }
        img {
          width: 32px;
          height: 32px;
          margin-bottom: 16px;
        }
        .mt0{
          margin-top: 0 !important;
        }
        .arrow_box {
          margin-top: 4%;
          // padding-left: 10%;
          // padding-right: 10%;
          width: 100%;
          position: relative;
          img{
            width: 100%;
            height: 10px;
          }
          .green{
            color: #63A103;
          }
          .red{
            color: #D9001B;
          }
          .need_box{
            position: absolute;
            top: 26px;
            left: 50%;
            transform: translateX(-50%);
            color: #ccc;
            display: flex;
            flex-wrap: nowrap;
            justify-content: center;
            width: 100%;
          }
          // .line {
          //   width: 100px;
          //   border-bottom: 1px dashed #ccc;
          //   position: relative;
          //   .right_arrow {
          //     position: absolute;
          //     right: -10px;
          //     top: -5px;
          //     width: 0;
          //     height: 0;
          //     border-top: 6px solid transparent; /* 顶部边框透明 */
          //     border-bottom: 6px solid transparent; /* 底部边框透明 */
          //     border-left: 6px solid #ccc; /* 左侧边框为箭头颜色，向右突出 */
          //     display: inline-block; /* 让箭头可以和其他元素并排显示 */
          //   }
          // }
        }
      }
      // .step_li:last-child .line {
      //   width: 0;
      // }
      // .step_li:last-child .line .right_arrow {
      //   border: none;
      // }
    }
    .title_que{
      font-size: 22px;
      text-align: left;
      margin-top: 42px;
      margin-bottom: 30px;
    }
    .content_box {
      .process_li{
        min-height: auto;
        position: relative;
        margin-bottom: 50px;
        .lock-img{
          position: absolute;
          top: -69px;
          left: 50%;
          transform: translateX(-50%);
          width: 246px;
          height: 157px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .bubble{
          background: url('../../assets/icon/bubble/u56.svg') no-repeat;
          background-size: contain;
          width: 68px;
          height: 34px;
          color: #fff;
          margin-right: 16px;
          display: flex;
          align-items: center;
          position: relative;
          justify-content: center;
          font-weight: 600;
          .triangle{
            position: absolute;
            bottom: 0;
            right: 10px;
            transform: rotate(38deg);
            width: 10px;
          }
        }
        .bg_black{
          background: url('../../assets/icon/bubble/u169.svg') no-repeat !important;
          background-size: contain !important;
          width: 68px;
          height: 34px;
        }
      }
      .process_li {
        margin-bottom: 30px;
        border-radius: 12px;
        margin-top: 90px;
        &:first-child{
          margin-bottom: 128px;
        }
      }
      
      .process_con{
        position: relative;
        padding-bottom: 30px;
      }
      
      .img_container{
        position: absolute;
        top: -102px;
        right: 33px;
        z-index: 5;
        overflow: hidden;
      }
      
      .repair_img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .top_box {
        font-size: 18px;
        padding: 40px 0;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 0;
        img {
          width: 16px;
          height: 16px;
          margin-left: 16px;
        }
        .title {
          color: var(--themeColor);
          font-family: "Source Han Sans CN";
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-shadow: -2px -2px 0 #FFF, 2px -2px 0 #FFF, -2px 2px 0 #FFF, 2px 2px 0 #FFF, 0 0 8px rgba(255, 255, 255, 0.8);
        }
        .order_box {
          width: 32px;
          height: 32px;
          line-height: 32px;
          color: #fff;
          background: var(--themeColor);
          border-radius: 50%;
          margin-right: 12px;
        }
        .tag {
          padding: 0 4px;
          border-radius: 10px;
          font-size: 12px;
          margin-left: 8px;
        }
        .tag_red{
          border: 1px solid red;
          color: red;
        }
        .tag_green{
          border: 1px solid green;
          color: green;
        }
      }
      .handle{
        background: var(--themeColor);
        color: #fff;
        border-radius: 8px;
        padding: 8px 12px;
        cursor: pointer;
        img{
          margin-right: 6px;
          margin-left: 0 !important;
        }
      }
      .bon_l {
        border: 1px solid var(--themeColor);
        border-radius: 8px;
        font-size: 16px;
        padding: 5px 12px;
        color: var(--themeColor);
        margin-right: 12px;
        cursor: pointer;
        text-align: center;
      }
      .smile{
        font-size: 16px;
        padding: 6px 12px;
        img{
          margin-right: 6px !important;
        }
      }
      .process_li:nth-child(1) .repair_box{
        background: #E0E8F5;
        border-radius: 0 0 52px 52px;
      }
       .process_li:nth-child(2) .repair_box{
        background: #E0ECE2;
        border-radius: 0 0 52px 52px;

      }
      .process_li:nth-child(1) .top_box {
        border-radius: 52px 52px 20px 20px;
        background: #CDD7E3;
      }
      
      .process_li:nth-child(2) .top_box {
        border-radius: 52px 52px 20px 20px;
        background: #CDE3D1;
      }
      .process_li:nth-child(1) .step_content{
        background: #E8EFF9;
      }
      .process_li:nth-child(2) .step_content{
        background: rgb(237, 244, 238);
      }
      .process_li:nth-child(1) .img_container{
        width: 233px;
        height: 262px;
      }
      .process_li:nth-child(2) .img_container{
        left: 28px;
        top: -104px;
        width: 198px;
        height: 265px;
      }
      
      .blue_bg {
        background-color: rgba(255, 255, 255, 0.9);
        margin: 0 20px;
        padding: 15px 20px;
        border-radius: 10px;
        margin-bottom: 15px;
      }
      
      .green_bg {
        background-color: rgba(255, 255, 255, 0.9);
        margin: 0 20px;
        padding: 15px 20px;
        border-radius: 10px;
        margin-bottom: 15px;
      }
      
      .bg_img{
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: scroll;
      }
      .blue_bg_img{
        background-image: url('../../assets/theme-1.png');
      }
      .green_bg_img{
        background-image: url('../../assets/theme-2.png');
      }
      .repair_box{
        position: relative;
        width: 96%;
        margin: 0 auto;
        padding: 26px !important;
        padding-top: 80px;
      }
      /* 图片底部虚化效果 */
      .process_li .img_container::after {
        content: '';
        position: absolute;
        bottom: 6px;
        left: -10px;
        width: 115%;
        height: 30px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
        pointer-events: none;
        z-index: 99;
      }
      .process_li:last-child .img_container::after{
        bottom: 3px;
        width: 100%;
      }
      .info_box {
        padding: 16px 26px;
        font-size: 16px;
        .flex_box:last-child {
          margin-bottom: 0;
        }
        .step_content{
          // margin-right: 32px;
          position: relative;
          border-radius: 24px;
          padding: 24px;
          margin-bottom: 24px;
          z-index: 99;
          .step_title{
            font-size: 22px;
            font-weight: bold;
          }
          &:last-child{
            margin-bottom: 0;
          }
        }
        .desc {
          white-space: pre-line;
          word-wrap: break-word;
          line-height: 1.6;
          text-align: left;
          margin-left: 28px;
        }
        img {
          width: 16px;
          height: 16px;
          margin-right: 16px;
        }
        .down_arrow {
          position: absolute;
          left: 5px;
          top: 35px;
          div {
            color: var(--themeColor);
            font-size: 14px;
          }
          img {
            height: 48px;
            width: auto;
          }
        }
      }
    }
    .content_bom{
      margin-top: 36px;
      .tabs {
        margin-bottom: 44px;
        margin-top: 120px;
        .pres {
          margin-bottom: 24px;
          img {
            max-width: 35.8rem;
          }
        }
        .file {
          text-align: left;
        }
      }
      .pic_box{
        border: 1px dashed #ccc;
        width: 100%;
        height: 580px;
        position: relative;
        padding: 32px;
        .amplify{
          position: absolute;
          top: 4px;
          right: 4px;
          width: 32px;
          cursor: pointer;
        }
      }
      .step_ul {
        border: 1px solid #e0e5f0;
        padding: 16px;
        margin-top: 24px;
        .step_li {
          margin-left: 34px;
          margin-bottom: 16px;
          .order {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            color: var(--themeColor);
            background: var(--themeColor1);
            font-size: 20px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 8px;
            margin-bottom: 16px;
          }
          .li_r {
            font-size: 16px;
            margin-left: 16px;
            .li_title {
              margin-bottom: 12px;
              padding: 23px 20px;
              border-radius: 8px;
              box-shadow: 0px 2px 0px 0px rgba(49, 104, 236, 0.4) inset,
                0px 4px 4px 0px rgba(0, 0, 0, 0.1);
            }
            .remark {
              color: #999;
              padding-left: 20px;
            }
          }
          .flex {
            align-items: normal;
          }
        }
      }
      .precautions {
        margin-top: 66px;
        padding: 24px 20px;
        background: #f8f8f8;
        font-size: 16px;
        color: #7b7b7b;
        text-align: left;
        div:first-child {
          font-weight: 700;
          margin-bottom: 16px;
        }
      }
    }
    .question {
      text-align: left;
      margin-bottom: 10%;
      .ques_con {
        padding: 24px;
        background: #f7f8fb;
        border-radius: 4px;
        margin-bottom: 16px;
        .da {
          color: #ff0000;
        }
        .da_con {
          color: #7a8ba4;
        }
      }
      .wen {
        color: var(--themeColor);
      }
      .ques_list {
        border: 1px solid #e0e5f0;
        border-radius: 4px;
        padding: 2%;
        margin-bottom: 16px;
      }
    }
    .file_class{      
      border-radius: 8px;
      border: 1px solid  #E0E5F0;
      padding: 12px;
      justify-content: space-between;
      font-size: 16px;
      margin-bottom: 24px;
      a{
        color: #7A8BA4;
        div{
          margin-right: 8px;
        }
      }
    }
  }
  /deep/.ant-anchor-link-active{
    // padding-left: 0;
    background: linear-gradient(90deg, #EBEFFC 0%, rgba(235, 239, 252, 0) 100%);
  }
  /deep/.ant-anchor-ink-ball{
    width: 0;
    height: 0;
    border: none;
  }
}
  /deep/.ant-modal-close-x{
  display: none;
  }
  /deep/.ant-modal-body{
    padding: 0;
  }
</style>
